export { default as Spacer } from './Spacer';
export { spacerAdapter } from './adapters';
